import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { withRouter } from "../../_shared/withRouter";
import { useTranslation } from "react-i18next";
// import TextFieldComponent from "../_common/textFieldComponent";
import {
  userLoginApi,
  userLanguagesApi,
  userVerifyLoginApi,
  userLevelProgressApi,
  fetchUserProfileApi,
  userBrandInfo,
} from "../../user/_userActions";
import { globalLoader, globalAlert, addOrgDetailsFunc } from "../../actions/commonActions";
import { superAdminLoginApi } from "../../superadmin/_actions";

import { adminLoginApi, adminLoginMFAApi, adminResendMFAApi } from "../../admin/_actions";
import TimerComp from "../../_shared/timer";
import InputComponent from "../_common/inputComponent";
import LanguageSelector from "../_common/languageSelector";
import TermsModal from "./termsModal";
import { TERMSMODALCONTENT } from "../../actionTypes/types";
import {
  ORGANIZATION_LANGUAGE_CONTROL_ENABLED,
  SUPPORTED_LANGUAGES,
  withNativeNames,
} from "../../i18n/languages";
import { loadLanguage } from "../../i18n/i18n";
import { getAdminDefaultPath } from "../admin/sidebarVisibility";
import { shouldClearSessionForLogin } from "../../_shared/routeSession";
// import { phone } from "faker/locale/en_AU_ocker";

const LoginComponent = (props) => {
  const { t, i18n } = useTranslation();
  const [values, setValues] = useState({
    phone: "",
    otp: "",
  });
  const [mobileError, setMobileError] = useState(false);
  const [mobileMinError, setMobileMinError] = useState(false);
  const [email, setEmail] = useState("");
  const [emptyEmail, setEmptyEmail] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [emptyPassword, setEmptyPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [toggleOtp, setToggleOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isMFA, setIsMFA] = useState(false);
  const [MFAOTP, setMFAOTP] = useState("");
  const [emptyMFAOTP, setEmptyMFAOTP] = useState("");
  const [termsModal, setTermsModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("userLanguage") || "en"
  );
  const [userLanguages, setUserLanguages] = useState(SUPPORTED_LANGUAGES);
  const requestedLanguageRef = useRef(
    localStorage.getItem("userLanguage") || "en"
  );

  useEffect(() => {
    document.querySelector("body").classList.remove("overflow-hidden-own");
    document.querySelector("html").classList.remove("overflow-hidden-own");
    basicAuth();
  }, []);

  useEffect(() => {
    if (props.roleType !== "user") return undefined;

    // TEMPORARY: Language selection is open to all supported languages so a
    // new user can choose a language before their organisation is known.
    // FUTURE: Enabling the feature flag below restores the organisation lookup
    // and limits this dropdown to the languages configured by that admin.
    if (!ORGANIZATION_LANGUAGE_CONTROL_ENABLED) {
      setUserLanguages(SUPPORTED_LANGUAGES);
      return undefined;
    }

    const normalizedMobile = String(values.phone || "").replace(/^0+/, "");
    if (!/^\d{10}$/.test(normalizedMobile)) {
      setUserLanguages([{ code: "en", name: "English" }]);
      setSelectedLanguage("en");
      localStorage.setItem("userLanguage", "en");
      i18n.changeLanguage("en");
      return undefined;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const res = await userLanguagesApi(normalizedMobile);
        if (cancelled) return;
        const languages = withNativeNames(res?.data?.data?.languages || []);
        const effectiveLanguages = languages.length > 0
          ? languages
          : [{ code: "en", name: "English" }];
        const allowedCodes = effectiveLanguages.map((language) => language.code);
        const defaultLanguage = allowedCodes.includes(res?.data?.data?.defaultLanguage)
          ? res.data.data.defaultLanguage
          : allowedCodes[0];
        setUserLanguages(effectiveLanguages);
        const requestedLanguage = requestedLanguageRef.current;
        const effectiveLanguage = allowedCodes.includes(requestedLanguage)
          ? requestedLanguage
          : defaultLanguage;
        requestedLanguageRef.current = effectiveLanguage;
        setSelectedLanguage(effectiveLanguage);
        localStorage.setItem("userLanguage", effectiveLanguage);
        await loadLanguage(effectiveLanguage);
        i18n.changeLanguage(effectiveLanguage);
      } catch (error) {
        if (cancelled) return;
        setUserLanguages([{ code: "en", name: "English" }]);
        requestedLanguageRef.current = "en";
        setSelectedLanguage("en");
        localStorage.setItem("userLanguage", "en");
        i18n.changeLanguage("en");
      }
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [i18n, props.roleType, values.phone]);

  const basicAuth = async () => {
    const activePortal = localStorage.getItem("portalRole");
    // A login page may be opened in another tab or reached by testing a
    // different portal URL. Only clear credentials belonging to this login's
    // own portal (or a legacy untagged session); never log an admin out merely
    // because /user/login or /superadmin/login was visited.
    if (shouldClearSessionForLogin(activePortal, props.roleType)) {
      localStorage.removeItem("ecauthtoken");
      localStorage.removeItem("ecsecuretoken");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("portalRole");
    }
    globalLoader(false);
  };

  const phoneValidation = (num) => {
    if (!num) {
      setErrors({ phoneMsg: t("user.login.phoneEmpty") });
      setMobileError(true);
      return false;
    }
    if (num.length < 10) {
      setErrors({ phoneMsg: t("user.login.phoneMinDigits") });
      setMobileMinError(true);
      return false;
    }
    return true;
  };

  const adminValidation = () => {
    let flag = true;
    if (!email) {
      setEmptyEmail(true);
      flag = false;
    }
    if (!password) {
      setEmptyPassword(true);
      flag = false;
    }
    if (invalidEmail) {
      flag = false;
    }
    return flag;
  };

  const otpValidation = () => {
    let otp = values.otp;
    if (!otp) {
      setErrors({ otpMsg: t("user.login.otpRequired") });
      return false;
    } else {
      setErrors({ otpMsg: "" });
      return true;
    }
  };

  const onTermsModalClose = (flag = false) => {
    if (flag) {
      props?.history?.push({ pathname: `/${props.roleType}/register` });
    }
    setTermsModal(false);
  };

  const resolveAdminLandingPath = async () => {
    try {
      const brandRes = await userBrandInfo();
      const orgBrandInfo = brandRes?.data?.data?.orgBrandInfo || {};
      if (Object.keys(orgBrandInfo).length) addOrgDetailsFunc(orgBrandInfo);
      const requestedPath = props?.location?.state?.from;
      if (
        typeof requestedPath === "string" &&
        requestedPath.startsWith("/admin/") &&
        requestedPath !== "/admin/login"
      ) {
        // The admin feature guard performs the final capability check after
        // login and redirects disabled routes to the organisation default.
        return requestedPath;
      }
      return getAdminDefaultPath(orgBrandInfo);
    } catch {
      return "/admin/manage-users";
    }
  };

  const handleOtp = async () => {
    let phoneValid = await phoneValidation(values?.phone);

    if (phoneValid) {
      globalLoader(true);
      let obj = {
        mobile: values?.phone,
      };
      let res;
      const roleType = props.roleType;
      if (roleType === "superadmin") {
      } else if (roleType === "admin") {
      } else {
        res = await userLoginApi(obj);
      }

      if (res?.data?.status === 200) {
        setToggleOtp(true);
        setValues({ ...values, otp: "" });
        globalAlert("success", res?.data?.message);
        setOtpSent(true);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);

      // setErrors({});
      // setToggleOtp(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const roleType = props.roleType;
    if (!toggleOtp && roleType === "user") {
      handleOtp();
    } else {
      globalLoader(true);

      let res;
      let obj;
      if (otpValidation() && roleType === "user") {
        obj = {
          mobile: values?.phone,
          otp: values?.otp,
        };
        res = await userVerifyLoginApi(obj);
        if (res?.data?.status === 200) {
          localStorage.setItem("portalRole", "user");
          globalAlert("success", res?.data?.message);

          const userProfileApi = await fetchUserProfileApi();
          if (userProfileApi?.data?.status === 200 && userProfileApi?.data?.data?.questions?.show) {
            props.history.push(`/${props.roleType}/missing-profile`);
          } else {
            let progress = await userLevelProgressApi();
            if (progress?.data?.status === 200) {
              if (!progress?.data?.data?.skipVideosPage) {
                props.history.push(`/${props.roleType}/video`);
              } else if (
                progress?.data?.data?.skipVideosPage &&
                !progress?.data?.data?.skipQuizPage
              ) {
                props.history.push(`/${props.roleType}/quiz`);
              } else if (progress?.data?.data?.quizLevelPassed) {
                props.history.push(`/${props.roleType}/dashboard`);
              } else {
                props.history.push(`/${props.roleType}/video`);
              }
            } else {
              globalAlert("error", res?.data?.message);
              window.location.reload();
            }
          }

          // props.history.push(`/${props.roleType}/quiz`);
        } else {
          globalAlert("error", res?.data?.message);
        }
      } else {
        if (adminValidation()) {
          obj = {
            email: email,
            password: password,
          };
          if (roleType === "superadmin") {
            res = await superAdminLoginApi(obj);
            if (res?.data?.status === 200) {
              localStorage.setItem("portalRole", "superadmin");
              globalAlert("success", res?.data?.message);
              localStorage.setItem("userEmail", email);
              const requestedPath = props?.location?.state?.from;
              props.history.push(
                typeof requestedPath === "string" &&
                  requestedPath.startsWith("/superadmin/") &&
                  requestedPath !== "/superadmin/login"
                  ? requestedPath
                  : `/${roleType}/manage-organisations`
              );
            } else {
              let errMsg = res?.data?.message;
              if (errMsg === "Invalid credentials") {
                errMsg = "Invalid username or password. Please try again.";
              }
              globalAlert("error", errMsg);
            }
          } else if (roleType === "admin") {
            let res;
            try {
              res = await adminLoginApi(obj);
            } catch (err) {
              let errMsg = err?.response?.data?.message || t("common.somethingWentWrong");
              if (errMsg === "Invalid credentials") {
                errMsg = "Invalid username or password. Please try again.";
              }
              globalAlert("error", errMsg);
              globalLoader(false);
              return;
            }
            if (res?.data?.status === 200) {
              // Store timeout value from API response
              localStorage.setItem('adminTimeout', res?.data?.data?.timeout || 60);
              localStorage.setItem("userEmail", email);
              if (res?.data?.data?.isMfaRequired) {
                setIsMFA(true);
                setOtpSent(true);
              } else {
                localStorage.setItem("portalRole", "admin");
                globalAlert("success", res?.data?.message);
                const nextPath = await resolveAdminLandingPath();
                props.history.push(nextPath);
              }
            } else {
              let errMsg = res?.data?.message;
              if (errMsg === "Invalid credentials") {
                errMsg = "Invalid username or password. Please try again.";
              }
              globalAlert("error", errMsg);
            }
          }
        }
      }
    }
    globalLoader(false);
  };

  const handleSubmitMFA = async (e) => {
    e.preventDefault();
    try {
      if (MFAOTP?.length > 5) {
        globalLoader(true);
        const res = await adminLoginMFAApi({ otp: MFAOTP });
        if (res?.data?.status === 200) {
          localStorage.setItem("portalRole", "admin");
          localStorage.setItem("userEmail", email);
          globalAlert("success", res?.data?.message);
          const nextPath = await resolveAdminLandingPath();
          props.history.push(nextPath);
        } else {
          globalAlert("error", res?.data?.message);
        }
      } else {
        setEmptyMFAOTP(true);
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        setIsMFA(false);
        setMFAOTP("");
      }
      globalAlert(
        "error",
        err?.response?.data?.message || t("common.somethingWentWrong")
      );
    } finally {
      globalLoader(false);
    }
  };

  const setTimerOver = () => {
    setOtpSent(false);
  };

  const handleResendMFA = async () => {
    try {
      globalLoader(true);
      const res = await adminResendMFAApi();
      if (res?.data?.status === 200) {
        setMFAOTP("");
        setEmptyMFAOTP(false);
        setOtpSent(true);
        globalAlert("success", res?.data?.message);
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        setIsMFA(false);
        setMFAOTP("");
      }
      globalAlert(
        "error",
        err?.response?.data?.message || t("common.somethingWentWrong")
      );
    } finally {
      globalLoader(false);
    }
  };

  return (
    <>
      <main className="auth-screen-wrapper">
        <div className="fix-width-wrapper px-3 mx-auto">
          <div className="auth-body-wrapper">
            <div className="logo-wrapper text-center">
              <img
                src="../assets/icons/eC-Card-Logo.svg"
                alt="EC Card Logo"
                className="logo"
              />
            </div>
            {props.roleType === "user" && (
              <div className="lms-auth-heading-extra">
                <LanguageSelector
                  variant="dark"
                  languages={userLanguages}
                  value={selectedLanguage}
                  onChange={(language) => {
                    requestedLanguageRef.current = language;
                    setSelectedLanguage(language);
                  }}
                />
              </div>
            )}

            {!isMFA ? (
              <>
                <form onSubmit={(e) => handleSubmit(e)} className="form-own">
                  {props.roleType === "user" ? (
                    <>
                      <div className="form-group reg-date login-page pt-3">
                        <InputComponent
                          placeholder={t("user.login.mobilePlaceholder")}
                          label={`${t("user.login.mobileLabel")} *`}
                          type="text"
                          name="phone"
                          color="#ffffff"
                          theme="primary"
                          inputFor="number"
                          maxLength="11"
                          disabled={toggleOtp}
                          value={values?.phone}
                          autoComplete="off"
                          handleCallback={(val) => {
                            const name = "phone";
                            setValues({ ...values, [name]: val });
                          }}
                        />
                        <span className="error-text font-12 pl-2">
                          {values?.phone && mobileMinError && errors.phoneMsg}
                          {!values?.phone && mobileError && errors.phoneMsg}
                        </span>
                      </div>
                      {toggleOtp && (
                        <>
                          <div className="form-group login-page">
                            <InputComponent
                              placeholder={t("user.login.otpLabel")}
                              label={`${t("user.login.otpLabel")} *`}
                              type="text"
                              name="otp"
                              inputFor="number"
                              theme="primary"
                              color="#ffffff"
                              maxLength="6"
                              value={values?.otp}
                              autoComplete="off"
                              handleCallback={(val) => {
                                const name = "otp";
                                setValues({
                                  ...values,
                                  [name]: val.replace(/\D/g, "").slice(0, 6),
                                });
                              }}
                            />

                            <span className="error-text font-12 pl-2">
                              {errors.otpMsg}
                            </span>
                          </div>

                          <div className="resend-otp-txt text-center mb-3">
                            {otpSent ? (
                              <TimerComp setTimerOver={setTimerOver} />
                            ) : (
                              <span
                                className="cursor text-color-light-blue border-color-light-blue"
                                onClick={handleOtp}
                              >
                                {t("user.login.resendOtp")}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <Button
                              type="submit"
                              className="btn btn-secondary-own btn-block btn-own w-100"
                            >
                              <span className="text-color-primary">{t("user.login.loginButton")}</span>
                            </Button>
                          </div>
                        </>
                      )}

                      {!toggleOtp && (
                        <div className="form-group pt-3 pb-2 login-send-otp-action">
                          {/* <Button
                            // onClick={handleOtp}
                            variant="secondary"
                            className="btn-secondary-own button btn btn-block btn-own"
                            type="submit"
                          >
                            <span className="text-color-primary">{t("user.login.sendOtp")}</span>
                          </Button> */}
                          <button type="submit" className="btn primary-btn btn-block lms-auth-submit w-100">
                            {t("user.login.sendOtp")}
                          </button>
                        </div>
                      )}
                      <div className="form-group pt-4 d-flex justify-content-center">
                        {t("user.login.newUser")}&nbsp;
                        <div
                          onClick={() => setTermsModal(true)}
                          style={{ cursor: "pointer" }}
                          className="pl-1 text-color-light-blue"
                        >{t("user.login.registerNow")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="pt-1">
                        <p className="login-text text-center fw-bold">
                          {t("user.login.loginToAccess")}
                        </p>

                        <div className="form-group reg-date login-page">
                          <InputComponent
                            placeholder={t("user.login.emailPlaceholder")}
                            label={t("user.login.emailPlaceholder")}
                            name="email"
                            type="text"
                            keyType="email"
                            theme="primary"
                            color="#ffffff"
                            inputFor="number"
                            maxLength={40}
                            disabled={toggleOtp}
                            value={email}
                            autoComplete={"email" + Math.random()}
                            handleCallback={(val, flag) => {
                              setInvalidEmail(flag);
                              setEmail(val);
                            }}
                          />
                          <div className="error-text font-12 pl-2">
                            {!email && emptyEmail && (
                              <span>{t("user.login.emailRequired")}</span>
                            )}
                            {email && invalidEmail && (
                              <span>{t("user.login.emailInvalid")}</span>
                            )}
                          </div>
                        </div>
                        <div className="form-group reg-date login-page position-relative">
                          {/* <input
                        placeholder="Password"
                        className="form-control"
                        type={passwordVisible ? "text" : "password"}
                        onChange={(ev) => setPassword(ev.target.value)}
                        maxLength={30}
                        autoComplete="off"
                        value={password}
                      /> */}
                          <InputComponent
                            placeholder={t("user.login.passwordPlaceholder")}
                            label={t("user.login.passwordPlaceholder")}
                            name="password"
                            type={passwordVisible ? "text" : "password"}
                            theme="primary"
                            color="#ffffff"
                            maxLength={30}
                            value={password}
                            autoComplete="off"
                            handleCallback={(val) => {
                              setPassword(val);
                            }}
                          />
                          <div
                            className="login-password cursor"
                            onClick={() => {
                              setPasswordVisible((current) => !current);
                            }}
                          >
                            {passwordVisible ? (
                              <i className="far fa-eye"></i>
                            ) : (
                              <i className="far fa-eye-slash"></i>
                            )}
                          </div>
                          <div className="error-text font-12 pl-2">
                            {!password && emptyPassword && (
                              <span>{t("user.login.passwordRequired")}</span>
                            )}
                          </div>
                        </div>

                        <div className="form-group pt-3">
                          <Button
                            type="submit"
                            className="btn btn-secondary-own btn-block btn-own w-100 "
                          >
                            <span className="text-color-primary">{t("user.login.loginButton", "Log in")}</span>

                          </Button>
                        </div>

                        {props.roleType !== "user" && (
                          <div className="pb-3  pt-2 text-center d-flex flex-wrap justify-content-between">
                            <Link to={`/${props?.roleType}/activate-account`}>
                              <span className=" text-color-light-blue">
                                {t("user.login.activateAccount")}
                              </span>
                            </Link>
                            <Link to={`/${props.roleType}/forgot-password`}>
                              <span className=" text-color-light-blue">
                                {t("user.login.forgotPassword")}
                              </span>
                            </Link>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  <div className="form-group pt-2 d-flex justify-content-center">
                    <Link
                      to={`/terms-and-conditions`}
                      state={{ sourcePortal: props.roleType }}
                    >
                      <span className=" text-color-light-blue px-3">
                        {t("user.login.termsAndConditions")}
                      </span>
                    </Link>
                    <Link
                      to={`/accessibility-statement`}
                      state={{ sourcePortal: props.roleType }}
                    >
                      <span className=" text-color-light-blue">
                        {t("common.accessibilityStatement")}
                      </span>
                    </Link>
                    <Link
                      to={`/privacy-policy`}
                      state={{ sourcePortal: props.roleType }}
                    >
                      <span className=" text-color-light-blue">
                        {t("user.login.privacyPolicy")}
                      </span>
                    </Link>
                  </div>
                </form>
              </>
            ) : (
              // MFA
              <>
                <form onSubmit={(e) => handleSubmitMFA(e)} className="form-own">
                  {/* <h2 className="mb-0 pt-4">MFA</h2> */}
                  <p className="text-center">
                    {t("user.login.mfaCodeSent")}
                  </p>

                  <div className="form-group reg-date">
                    <InputComponent
                      placeholder={t("user.login.mfaCodeLabel")}
                      label={`${t("user.login.mfaCodeLabel")} *`}
                      name="otp"
                      type="number"
                      keyType="email"
                      theme="primary"
                      inputFor="number"
                      maxLength={6}
                      value={MFAOTP}
                      handleCallback={(val) => {
                        setMFAOTP(val);
                      }}
                    />
                    <div className="error-text font-12 pl-2">
                      {!MFAOTP && emptyMFAOTP && (
                        <span>{t("user.login.mfaCodeRequired")}</span>
                      )}
                    </div>
                  </div>

                  <div className="form-group pt-3">
                    <Button
                      type="submit"
                      className="btn btn-secondary-own btn-block btn-own w-100"
                    >
                      <span className="text-color-primary">{t("user.login.mfaSubmit")}</span>
                    </Button>
                  </div>

                  <div className="pb-3  pt-2 text-center d-flex flex-wrap justify-content-center w-100 text-white">
                    {otpSent ? (
                      <TimerComp
                        setTimerOver={setTimerOver}
                        msg={t("user.login.mfaResendCode")}
                        seconds={60}
                      />
                    ) : (() => {
                      const resendText = t("user.login.mfaResendCode");
                      const match = resendText.match(/^(.*?[?؟])\s*(.*)$/);
                      const part1 = match ? match[1] : "";
                      const part2 = match ? match[2] : resendText;
                      return (
                        <div className="w-100 text-center">
                          {part1 && <span className="text-white me-1">{part1}</span>}
                          <span
                            className="cursor text-color-secondary"
                            onClick={handleResendMFA}
                          >
                            {part2}
                          </span>
                        </div>
                      );
                    })()}
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </main>
      {termsModal && (
        <TermsModal
          open={termsModal}
          onCloseModal={onTermsModalClose}
          heading={t(TERMSMODALCONTENT.heading)}
          body={t(TERMSMODALCONTENT.body)}
        />
      )}
    </>
  );
};

export default withRouter(LoginComponent);
